<template>
  <div class="rms-desk-wraper">
    <div class="rms-desk-header">
      <a-row>
        <a-col :span="12">
          <a-input-search
            v-model="keyword"
            placeholder="请输入桌号/桌台名"
            style="width:300px"
            @search="fetchListData"
          />
          <a-button type="primary" @click="reflesh" class="ml">刷新</a-button>
          <span class="tr" style="padding-top:4px;margin-left:20px">
            显示停用
            <a-switch
              v-model="showForbiddens"
              @change="fetchListData"
            ></a-switch>
          </span>
        </a-col>
        <a-col :span="12" class="tr">
          <a-dropdown>
            <a-button style="font-size: 15px;" type="primary">
              {{ selectedMarket }} <a-icon type="down" />
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item
                v-for="item in marketData"
                :key="item.Id"
                @click="changeMarket(item)"
              >
                <span>{{ item.Text }}</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-col>
      </a-row>
    </div>
    <div class="rms-desk-list_box">
      <div class="rms-desk-list" :style="{ gridTemplateColumns: gridColumns }">
        <div
          v-for="item in list"
          :key="item.TableId"
          :class="[
            'rms-desk-item',
            getFontColor(item.Color),
            { 'hover-table': hoverKeys.includes(item.OrderId) }
          ]"
          :style="{ background: item.Color }"
          @click="onTableClick(item)"
          @mouseover="hoverEvent($event, item)"
          @mouseleave="leaveEvent($event, item)"
        >
          <a-dropdown :trigger="['contextmenu']" style="height: 100%;">
            <div>
              <div class="flex">
                <div class="flex-item">
                  <a-tag
                    color="red"
                    v-if="item.IsVirtual"
                    style="margin-right: 0;line-height: 18px; height: 20px; padding: 0 2px;"
                  >
                    虚
                  </a-tag>
                  {{ item.TableCode }}
                </div>
                <div class="flex-item tc">
                  <i class="iconfont icon-chair2" style="font-size:18px"></i>
                  {{ item.Seat }}
                </div>
                <div class="flex-item tr" style="min-width: 63px;">
                  <span v-if="item.CheckInTime">
                    <a-icon type="clock-circle" />
                    {{ item.CheckInTime }}
                  </span>
                </div>
              </div>
              <div class="item-title tc">
                {{ item.TableName }}
              </div>
              <div class="item-contact">
                <span v-if="item.Contact">
                  <a-icon type="user" /> {{ item.Contact }}</span
                >
              </div>
              <div class="flex">
                <div class="flex-item" style="flex:2">
                  <a-tag v-if="item.OrderStatusName == '点餐'" color="green">
                    {{ item.OrderStatusName }}
                  </a-tag>
                  <a-tag v-if="item.OrderStatusName == '开台'" color="blue">
                    {{ item.OrderStatusName }}
                  </a-tag>
                  <a-tag color="#f50" v-if="item.HasUnconfirmedDish">
                    待确认
                  </a-tag>
                </div>
                <div class="flex-item tr">
                  <span v-if="item.Fee">￥{{ item.Fee }}</span>
                </div>
              </div>
            </div>
            <a-menu slot="overlay">
              <a-menu-item
                key="1"
                @click="checkOrderFood(item.OrderId)"
                v-if="item.Status == 0"
              >
                <a-icon type="form" /> 多桌点餐
              </a-menu-item>
              <a-menu-item
                key="2"
                @click="cleanTable($event, item)"
                v-if="item.ClearStatus == 0"
              >
                <img :src="img3" class="status-img" alt="" /> 清洁桌台
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>
    <a-row class="status-box">
      <a-col :span="14" class="status-section">
        <span v-for="(item, index) in statusList" :key="index"
          ><i :style="{ background: item.color }"></i>{{ item.text }}
          {{ item.count }}</span
        >
      </a-col>
      <a-col :span="10" class="total-box">
        <span
          >用餐人数：<b>{{ statusData.GuestNum }}</b></span
        >
        <span
          >上座率：<b>{{ statusData.Attendance }}</b></span
        >
        <span
          >开台率：<b>{{ statusData.UsingRate }}</b></span
        >
        <span>账务日期：{{ statusData.AccountDate }}</span>
      </a-col>
    </a-row>
    <span class="booking-btn" @click="openBookingList"
      >订餐<br />列表<em v-if="Number(bookingCount) > 0">{{
        bookingCount
      }}</em></span
    >
    <a-drawer
      title="预订列表"
      placement="right"
      width="560px"
      :closable="true"
      @close="closeBookingList"
      :visible="visible"
    >
      <a-tabs v-model="activeKey" @change="changeTab" style="margin-top:-20px">
        <a-tab-pane key="0">
          <div slot="tab">
            <a-badge :count="otherInfo.Booking" style="padding:0 12px">
              预订
            </a-badge>
          </div>
        </a-tab-pane>
        <a-tab-pane key="13" force-render>
          <div slot="tab">
            <a-badge :count="otherInfo.Unconfirmed" style="padding:0 12px">
              预订待确认
            </a-badge>
          </div>
        </a-tab-pane>
      </a-tabs>
      <data-table ref="dataTable" class="booking-table" :option="option">
      </data-table>
    </a-drawer>
    <OrderDetail ref="OrderDetail" @update="updateData"></OrderDetail>
  </div>
</template>

<script>
import "./rms.less";
import OrderDetail from "./OrderDetail";
import { DataTable } from "@/components/dataTable";
import img3 from "@/assets/images/r_icon3.png";
import moment from "moment";
export default {
  components: { DataTable, OrderDetail },
  data() {
    return {
      img3,
      list: [],
      screenWidth: "",
      statusList: [],
      // 接口返回的数据Data
      statusData: {},
      keyword: "",
      showForbiddens: false,
      hoverKeys: [],
      marketData: [],
      selectedMarket: "",
      bookingCount: 0,
      visible: false,
      gridData: [],
      params: { Status: 0 },
      activeKey: "0",
      columns: [
        {
          title: "订单号",
          dataIndex: "No",
          width: 80,
          customRender: (text, record) => {
            if (text) {
              const orderDetail = {
                click: () => {
                  this.$refs.OrderDetail.show(record.Id);
                }
              };
              return (
                <a-button type="link" size="small" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          }
        },
        {
          title: "联系人",
          width: 150,
          dataIndex: "Contact"
        },
        {
          title: "电话",
          width: 120,
          dataIndex: "Phone"
        },
        {
          title: "用餐人数",
          dataIndex: "PersonCount"
        }
      ],
      option: {},
      otherInfo: {}
    };
  },
  computed: {
    gridColumns() {
      const num = Math.round(this.screenWidth / 200);
      let columns = "";
      for (let i = 0; i < num; i++) {
        columns = `${columns} 1fr`;
      }
      return columns;
    }
  },
  created() {
    this.option = {
      headSearch: {
        width: "100%",
        colnum: 2,
        labelSize: "small",
        fixedLabelWidth: true,
        content: [
          {
            label: "用餐时间",
            type: "date",
            name: "CheckInTime"
          },
          {
            label: "关键字",
            name: "Keyword",
            props: { placeholder: "订单号/电话" }
          }
        ],
        onSubmitBefore: values => {
          if (values.CheckInTime) {
            values.CheckInTime = moment(values.CheckInTime).format(
              "YYYY-MM-DD"
            );
          }
          const json = { ...this.params, ...values };
          return json;
        }
      },

      grid: {
        api: "GetBookingOrderPage",
        params: this.params,
        columns: this.columns,
        autoLoad: false,
        onLoad: data => {
          this.otherInfo = data.Data.Other;
        }
      }
    };
    this.$post("Common_GetSelect", {
      Types: "RestaurantMarket"
    }).then(res => {
      this.marketData = res.Data.RestaurantMarket;
      this.selectedMarket = this.marketData.find(el => el.IsSelected).Text;
    });
    this.fetchListData();
    this.getBookingCount();
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    getBookingCount() {
      setTimeout(() => {
        this.$post("GetBookingOrderPage", {
          Status: 0,
          CheckInTime: this.statusData.AccountDate,
          PageIndex: 0,
          PageSize: 20
        }).then(res => {
          this.otherInfo = res.Data.Other;
          this.bookingCount =
            Number(this.otherInfo.Booking) + Number(this.otherInfo.Unconfirmed);
        });
      }, 1000);
    },
    openBookingList() {
      this.visible = true;
      this.activeKey = "0";
      this.params = {
        Status: 0,
        CheckInTime: this.statusData.AccountDate
      };
      this.$nextTick(() => {
        this.$refs.dataTable.$refs.headSearchForm.setData({
          CheckInTime: moment(this.statusData.AccountDate)
        });
        setTimeout(() => {
          this.$refs.dataTable.onHeadSearchSubmit({ ...this.params });
        }, 100);
      });
    },
    closeBookingList() {
      this.reflesh();
      this.visible = false;
    },
    updateData() {
      this.$refs.dataTable.onHeadSearchSubmit({ ...this.params });
    },
    changeTab(key) {
      this.params = {
        ...this.params,
        Status: key
      };
      this.$refs.dataTable.reload(this.params);
    },
    changeMarket(item) {
      this.$post("ChangeMarket", { Id: item.Id }).then(() => {
        this.selectedMarket = item.Text;
        location.reload();
      });
    },
    checkOrderFood(id) {
      this.$router.push({
        name: "OrderFood",
        query: {
          orderId: id
        }
      });
    },
    cleanTable(e, item) {
      this.$post("RMS_CleanTable", {
        Id: item.TableId
      }).then(() => {
        this.$message.success("操作成功");
        this.fetchListData();
      });
    },
    reflesh() {
      this.keyword = "";
      this.fetchListData();
      this.getBookingCount();
    },
    fetchListData() {
      const { keyword, showForbiddens } = this;
      this.$post("RMS_GetTableStatus", {
        Keyword: keyword,
        ShowForbiddens: showForbiddens
      }).then(res => {
        const data = res.Data;
        this.statusData = data;
        const totalAll = data.Occupy + data.EmptyClean + data.EmptyDirty;
        this.statusList = [
          {
            color: "url(/images/colorall.png)",
            text: "全部",
            count: totalAll
          },
          {
            color: data.OccupyColor,
            text: "在用",
            count: data.Occupy
          },
          {
            color: data.EmptyCleanColor,
            text: "空净",
            count: data.EmptyClean
          },
          {
            color: data.EmptyDirtyColor,
            text: "空脏",
            count: data.EmptyDirty
          }
        ];
        this.list = data.TableStatusDetails;
      });
      // const colors = ["#dddddd", "rgb(245, 161, 135)", "#44b549", "#999999"];
      // this.list = Array.from({ length: 50 }, (_, key) => ({
      //   id: key,
      //   name: `name_${key}`,
      //   color: colors[Math.ceil(Math.random() * colors.length - 1)]
      // }));
    },
    // 16进制颜色值转RGB
    colorHextoColorRGB(colorHex) {
      // 16进制颜色值的正则
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把颜色值变成小写
      let color = colorHex.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = [];
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return colorChange;
      } else {
        return color;
      }
    },
    getFontColor(color) {
      let RgbValueArry = "";
      if (color.indexOf("rgb") > -1) {
        const RgbValue = color.replace("rgb(", "").replace(")", "");
        RgbValueArry = RgbValue.split(",");
      } else {
        RgbValueArry = this.colorHextoColorRGB(color);
      }
      const grayLevel =
        RgbValueArry[0] * 0.299 +
        RgbValueArry[1] * 0.587 +
        RgbValueArry[2] * 0.114;
      if (grayLevel >= 192) {
        return "font-black";
      } else {
        return "font-withe";
      }
    },
    hoverEvent(e, item) {
      if (item.Status == 0 && !this.hoverKeys.includes(item.OrderId)) {
        this.hoverKeys.push(item.OrderId);
      }
    },
    leaveEvent(e, item) {
      if (this.hoverKeys.includes(item.OrderId)) {
        this.hoverKeys = this.hoverKeys.filter(el => el != item.OrderId);
      }
    },
    onTableClick(item) {
      if (item.Status == 1) {
        //开台
        this.$router.push({
          name: "OpenTable",
          query: {
            tableId: item.TableId
          }
        });
      } else if (item.Status == 0) {
        //点菜
        this.$router.push({
          name: "OrderFood",
          query: {
            orderId: item.OrderId,
            tableId: item.TableId
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@itemWidth: 100%;
@itemheight: 120px;
.rms-desk-wraper {
  padding: 10px;
  background: #f0f2f5;
  .rms-desk-header {
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
  }
  .rms-desk-list_box {
    height: calc(100vh - 223px);
    overflow-y: auto;
    padding: 10px 0;
    .rms-desk-list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-template-rows: auto;

      .rms-desk-item {
        background-color: #fff;
        height: @itemheight;
        margin: 3px;
        border-radius: 2px;
        padding: 5px;
        cursor: pointer;
        font-size: 16px;
        .flex-item {
          overflow: hidden;
          height: 24px;
          .ant-tag {
            margin-right: 2px;
          }
        }
        &:hover {
          box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
        }
        &.hover-table {
          background: #f60 !important;
        }
        .item-title {
          font-size: 22px;
          padding-top: 6px;
        }
        .item-contact {
          font-size: 12px;
          text-align: center;
          height: 20px;
          max-width: 170px;
          margin: 0 auto;
          & > span {
            display: block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // border: 1px solid #fff;
            // border-radius: 2px;
          }
        }
        &.font-black {
          color: #333;
        }
        &.font-withe {
          color: #fff;
        }
      }
    }
  }
  .status-box {
    border-top: 1px solid #ddd;
  }
  .total-box {
    text-align: right;
    margin-top: 10px;
    & > span {
      margin-left: 20px;
    }
  }
}
</style>
